<div class="unit-details-property-section-container display-flex flex-column grid-gap-16 section-item property-section">
  <div class="display-flex w-100 grid-gap-16">
    <div class="display-flex w-50 grid-gap-16">
      <div class="display-flex flex-column justify-content-space-between grid-gap-16 w-50">
        <div class="display-flex control-item grid-gap-8">
          <div class="body-small-bold width-120">Property manager:</div>
          <div class="body-small">
            <ng-container *ngIf="!propertyManagerEmail">{{ propertyManager }}</ng-container>
            <a *ngIf="propertyManagerEmail" href="mailto:{{ propertyManagerEmail }}">{{ propertyManager }}</a>
          </div>
        </div>
        <div class="display-flex control-item grid-gap-8">
          <div class="body-small-bold width-120">Unit type:</div>
          <div class="body-small">{{ unit?.unitType || '' }}</div>
        </div>
        <div class="display-flex control-item grid-gap-8">
          <div class="body-small-bold width-120">Finish:</div>
          <ng-container *ngIf="!readOnly">
            <app-radio-button-dropdown
              *ngIf="finish"
              [containerCss]="'width-150'"
              [labelCss]="'body-small-bold pl-0'"
              [valueCss]="'pre-option text-color dark'"
              [allowSearch]="false"
              [items]="finishList"
              [containerWidthCss]="'btn-small'"
              [attrPlaceholder]="'Select finish'"
              [formControl]="finish"
            ></app-radio-button-dropdown>
          </ng-container>
          <ng-container *ngIf="readOnly">
            <div class="body-small">{{ unit?.finish | enumerationValue: finishList }}</div>
          </ng-container>
        </div>
      </div>
      <div class="display-flex flex-column justify-content-space-between grid-gap-16 w-50">
        <div class="display-flex control-item grid-gap-8">
          <div class="body-small-bold width-100">Lease expires:</div>
          <div class="body-small">{{ unit?.dateLeaseExpires | date: 'MM/dd/yy' }}</div>
        </div>
        <div class="display-flex control-item grid-gap-8">
          <div class="body-small-bold width-100">Bd/Br:</div>
          <div class="body-small">{{ unit?.numberOfBedrooms || '-' }} / {{ unit?.numberOfBathrooms || '-' }}</div>
        </div>
        <div class="display-flex control-item grid-gap-8">
          <div class="body-small-bold width-100">Sf:</div>
          <div class="body-small">{{ unit?.squareFootage || '' }}</div>
        </div>
      </div>
    </div>
    <div class="display-flex flex-column justify-content-space-between w-50 grid-gap-16">
      <div class="display-flex flex-column">
        <div class="body-small-bold control-item">Description</div>
        <ng-container *ngIf="!readOnly">
          <app-input-area
            [inputCss]="'hp-50'"
            *ngIf="description"
            [attrDisable]="readOnly"
            [formControl]="description"
          ></app-input-area>
        </ng-container>
        <ng-container *ngIf="readOnly">
          <div class="body-small">{{ unit?.description || '' }}</div>
        </ng-container>
      </div>
      <div class="display-flex control-item grid-gap-8">
        <div class="body-small-bold">Address:</div>
        <div class="body-small">{{ propertyAddress || '' }}</div>
      </div>
    </div>
  </div>
</div>
